// =====================================================
// STATE — Application state factory (no global DOM refs)
// =====================================================

import type { ParsedDocument, DiffResult } from '../types';

export interface FredlineState {
  originalFile: File | null;
  revisedFile: File | null;
  lastDiffResult: DiffResult | null;
  originalZip: ParsedDocument | null;
  revisedZip: ParsedDocument | null;
  pendingFiles: File[];
}

export function createState(): FredlineState {
  return {
    originalFile: null,
    revisedFile: null,
    lastDiffResult: null,
    originalZip: null,
    revisedZip: null,
    pendingFiles: [],
  };
}
